import { z } from 'zod';
import { ConnectivityStatus } from '@evimo/types/enums/connectivity-status';

const KNOWN_STATUSES: readonly string[] = Object.values(ConnectivityStatus);

/**
 * Charger liveness fields of an asset row (ADR-0020): Redis value first, else Asset.lastSeenAt.
 * Lenient on purpose: an unexpected status (e.g. a newer API polled by an older web build) reads
 * as UNKNOWN for that cell instead of failing the whole table.
 */
export const assetLivenessFieldsSchema = {
  lastSeenAt: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? null),
  connectivityStatus: z
    .unknown()
    .optional()
    .transform((value): ConnectivityStatus | null => {
      if (value === null || value === undefined) {
        return null;
      }
      return typeof value === 'string' && KNOWN_STATUSES.includes(value)
        ? (value as ConnectivityStatus)
        : ConnectivityStatus.UNKNOWN;
    }),
};
